export const createCircleMapping = (s: number) => ({
  circle: { x: 0, y: 0, width: s * 2, height: s * 2, mask: true },
});
